const toc = document.querySelector(".lp-toc");
const tocDetails = toc.querySelector(".toc-details");
const tocSummary = toc.querySelector(".toc-summary");
const mediaQery = window.matchMedia("(min-width: 750px)").matches;
const tocLinks = tocDetails.querySelectorAll(".toc-link");
const reviewSection = document.querySelector("#judgeme_product_reviews");

window.addEventListener("load", () => {
  linkClickAction();

  function linkClickAction() {
    tocLinks.forEach((link) => {
      link.addEventListener("click", function (e) {
        if (!mediaQery) {
          tocDetails.open = false;
          document.body.classList.remove("overflow-hidden");
          toc.style.zIndex = "1";
        }
      });
    });
  }

  tocDetailsOpen();
  window.addEventListener("resize", tocDetailsOpen());

  function tocDetailsOpen() {
    if (mediaQery) {
      tocDetails.open = true;
    } else {
      tocDetails.open = false;
    }
  }

  checkObserver();

  function checkObserver() {
    const boxes = document.querySelectorAll(".lp-section");
    const options = {
      root: null,
      rootMargin: "-50% 0px",
      threshold: 0,
    };
    const observer = new IntersectionObserver(doWhenIntersect, options);
    boxes.forEach((box) => {
      observer.observe(box);
    });
    if (reviewSection) {
      observer.observe(reviewSection);
    }
  }

  function doWhenIntersect(entries) {
    entries.forEach((entry) => {
      if (entry.isIntersecting) {
        activateIndex(entry.target);
      }
    });
  }

  function activateIndex(element) {
    const showTitle = tocDetails.dataset.showTitle;
    const currentActiveIndex = tocDetails.querySelector(".toc-link.active");
    if (currentActiveIndex !== null) {
      currentActiveIndex.classList.remove("active");
    }
    const newActiveIndex = tocDetails.querySelector(`a[href='#${element.id}']`);
    if (newActiveIndex) {
      newActiveIndex.classList.add("active");
      if (showTitle == "true") {
        const indexTitle = tocDetails.querySelector(".toc-summary span");
        indexTitle.textContent = newActiveIndex.textContent;
      }
    }
  }

  tocSummary.addEventListener("click", function () {
    setTimeout(() => {
      if (tocDetails.open === false) {
        document.body.classList.remove("overflow-hidden");
        toc.style.zIndex = "1";
      } else {
        document.body.classList.add("overflow-hidden");
        toc.style.zIndex = "2";
      }
    }, 200);
  });
});
